export default __webpack_public_path__ + "static/media/Pyramide-besoins_perso_n6_realisation-de-soi.c52348c2.svg";